import { Link } from "@tanstack/react-router"

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/ui/card"
import { Logo } from "@repo/ui/components/ui/logo"

export type AuthLayoutProps = {
  children: React.ReactNode
  title: string
  footer?: React.ReactNode
}

export function AuthLayout({ children, title, footer }: AuthLayoutProps) {
  return (
    <Card className="glass-darker">
      <CardHeader className="flex flex-row items-center justify-between">
        <Link to="/">
          <Logo width={120} />
        </Link>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>{children}</CardContent>
      {footer && <CardFooter>{footer}</CardFooter>}
    </Card>
  )
}
